"use client";

import { useRef, useState, useTransition } from "react";
import { useRouter } from "next/navigation";
import { usePortalTranslations } from "../i18n/client";
import styles from "./PortalBookingCancel.module.css";

export function PortalBookingCancel({ slug, bookingUuid }: { slug: string; bookingUuid: string }) {
  const t = usePortalTranslations();
  const router = useRouter();
  const [confirm, setConfirm] = useState(false);
  const [busy, setBusy] = useState(false);
  const [refreshing, refresh] = useTransition();
  const [failed, setFailed] = useState(false);
  const [cancelled, setCancelled] = useState(false);
  const submitting = useRef(false);
  async function cancel() {
    if (submitting.current) return;
    submitting.current = true; setBusy(true); setFailed(false);
    try {
      const response = await fetch(`/api/client-portals/${encodeURIComponent(slug)}/bookings/${encodeURIComponent(bookingUuid)}/cancel`, { method: "POST" });
      if (!response.ok) throw new Error();
      setCancelled(true);
      refresh(() => router.refresh());
    } catch { setFailed(true); }
    finally { submitting.current = false; setBusy(false); }
  }
  return <div className={styles.cancel}>
    {cancelled ? <p role="status">{t("passes.booking.cancelled")}</p> : confirm ? <><p>{t("passes.booking.cancelConfirm")}</p><div><button type="button" onClick={cancel} disabled={busy || refreshing}>{t(busy ? "passes.saving" : "passes.booking.cancel")}</button><button type="button" onClick={() => { setConfirm(false); setFailed(false); }} disabled={busy}>{t("passes.back")}</button></div></> : <button type="button" onClick={() => setConfirm(true)}>{t("passes.booking.cancel")}</button>}
    {failed ? <p role="alert">{t("passes.booking.cancelError")}</p> : null}
  </div>;
}
